





























































































































































import Vue from 'vue';
import { CharacterSW25, Monster } from 'sw2.5-tools';
import NewTabLink from '../components/NewTabLink.vue';

const jsonpAdapter = require('axios-jsonp');

export default Vue.extend({
  components: {
    NewTabLink,
  },
  data: (): {
    yutorizeID: string,
    chatPalette: string,
    btnDisabled: boolean,
    successBar: boolean,
    errorBar: boolean,
    error: any,
    radioPlayStyle: string,
  } => ({
    yutorizeID : '',
    chatPalette: '',
    btnDisabled: false,
    successBar: false,
    errorBar: false,
    error: null,
    radioPlayStyle: 'keyboard',
  }),

  methods: {
    pushBtn(): void {

      // @ts-ignore
      this.$refs.form.validate();
      
      if(this.yutorizeID.trim() === '') return;

      if(!/^[0-9a-zA-Z]{6}$/.test(this.yutorizeID.trim())) return;

      this.btnDisabled = true;
      setTimeout(() => this.btnDisabled = false, 3000);

      this.axios.get(
        'https://yutorize.2-d.jp' + `/ytsheet/sw2.5/?id=${this.yutorizeID.trim()}&mode=json`,
        { adapter: jsonpAdapter }
      ).then(res => {
        try {
          if(res.data.type === 'm') {
            const monster = Monster.generateInstanceFromYutorize(res.data);
            this.chatPalette = monster.generateCommands();
            this.copy(monster.generateCCFOLIA());
          } else {  
            const outputOption = {
              addCommandsShortcut: this.radioPlayStyle === 'keyboard',
              addCommandsPartition:  this.radioPlayStyle !== 'keyboard',
              noStatus: this.radioPlayStyle !== 'keyboard',
            } 
            // @ts-ignore
            const chara = CharacterSW25.generateInstanceFromYutorize(res.data, outputOption);
            this.chatPalette = chara.generateCommands();
            this.copy(chara.generateCCFOLIA());
          }
          
        } catch(e) {
          console.error(e);
          this.error = e;
          this.errorBar = true;
        }
      }).catch(e => {
        if(e.response !== undefined) {
          console.error(e.response.data.error);
        }
        this.error = e;
        this.errorBar = true;
      }).finally(() => {
        
      });
        
    },
    copy(str: string): boolean{
      navigator.clipboard.writeText(str)
      .then(() => {
        this.successBar = true;
        return true;
      })
      .catch(e => {
        console.error(e);
        this.error = e;
        this.errorBar = true;
        return false;
      });
      return false;
    },
  }

})


